import {FC, ReactNode} from "react"

interface WrapperProps {
  condition: boolean | undefined
  wrapper: (children: ReactNode) => ReactNode
  children: ReactNode
}

const ConditionalWrapper: FC<WrapperProps> = ({condition, wrapper, children}) => (condition ? wrapper(children) : children)

export default ConditionalWrapper
